import { Megaphone, Users } from '@/lib/icons'

/** "Tarix" bo'limi hali bo'sh — birinchi broadcast hali yuborilmagan. */
export function BroadcastHistoryEmptyState() {
  return (
    <div className="flex min-h-[30vh] flex-col items-center justify-center gap-3 px-6 text-center">
      <div className="rounded-full bg-app-card p-4">
        <Megaphone size={28} className="text-app-hint" aria-hidden="true" />
      </div>
      <p className="max-w-xs text-sm text-app-hint">
        Hali birorta ommaviy xabar yuborilmagan. Yuqorida matn yozib, birinchisini yuboring.
      </p>
    </div>
  )
}

/** "Qo'lda tanlash" modalida qidiruv/ro'yxat bo'sh — masalan hali birorta bloger yo'q. */
export function ManualPickerEmptyState({ message }: { message: string }) {
  return (
    <div className="flex min-h-[30vh] flex-col items-center justify-center gap-3 px-6 text-center">
      <div className="rounded-full bg-app-card p-4">
        <Users size={28} className="text-app-hint" aria-hidden="true" />
      </div>
      <p className="max-w-xs text-sm text-app-hint">{message}</p>
    </div>
  )
}
